module.exports = __webpack_public_path__ + "static/media/product_list_1.86fddbdf.png";